import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/smartcell")({
  component: RouteComponent,
});

// Needed to make side nav tracking work
function RouteComponent() {
  return <Outlet />;
}
